import { render, staticRenderFns } from "./StepDelete.vue?vue&type=template&id=0524a6f3&"
import script from "./StepDelete.vue?vue&type=script&lang=js&"
export * from "./StepDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports